import React, { FC } from 'react'
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'
import { StringInputViewModel } from '@sitecore-jss/sitecore-jss-forms'

import BaseTextField from '../baseTextField'

const TextField: FC<ValueFieldProps<StringInputViewModel>> = (props) => (
  <BaseTextField type="text" {...props} />
)

export default TextField
